const breakpoints = {
  giantxl: 1440,
  giant: 1170,
  desktop: 992,
  tablet: 768,
  phone: 540,
};

export default breakpoints;
